import { render, staticRenderFns } from "./dataConnection.vue?vue&type=template&id=77d7e460"
import script from "./dataConnection.vue?vue&type=script&lang=ts"
export * from "./dataConnection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports